import { render, staticRenderFns } from "./TextWheel3D.vue?vue&type=template&id=4c55ea56&scoped=true"
import script from "./TextWheel3D.vue?vue&type=script&lang=js"
export * from "./TextWheel3D.vue?vue&type=script&lang=js"
import style0 from "./TextWheel3D.vue?vue&type=style&index=0&id=4c55ea56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55ea56",
  null
  
)

export default component.exports